import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import clsx from "clsx";
import { alpha, useTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import AppBar from "@mui/material/AppBar";
import CircularProgress from "@mui/material/CircularProgress";
import Toolbar from "@mui/material/Toolbar";
import InputBase from "@mui/material/InputBase";
import "./topMenu.css";
import { useDispatch, useSelector } from "react-redux";
import useScrollTrigger from "@mui/material/useScrollTrigger";
import Slide from "@mui/material/Slide";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import Button from "@mui/material/Button";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useLocation } from "react-router-dom";
import { useSnackbar } from "notistack";
import { Avatar } from "@mui/material";
import { isUserAuthorized, useDebounce, useViewport } from "../../helpers";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import WallpaperIcon from "@mui/icons-material/Wallpaper";
import Drawer from "@mui/material/Drawer";
import Divider from "@mui/material/Divider";
import ListSubheader from "@mui/material/ListSubheader";
import List from "@mui/material/List";
import QrCode2Icon from "@mui/icons-material/QrCode2";
import { useTranslation } from "react-i18next";
import ContactSupport from "../../assets/contact_support.svg";
import {
  Assessment,
  BurstMode,
  Business,
  Dashboard,
  PhonelinkSetup,
  Search as SearchIcon,
  SupervisedUserCircle,
} from "@mui/icons-material";
import TuneIcon from "@mui/icons-material/Tune";
import { searchService } from "../../services/index";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import EventIcon from "@mui/icons-material/Event";
import Badge from "@mui/material/Badge";
import EmailSnackBar from "../../components/emailSnackbar/EmailSnackBar";
import GroupWorkIcon from "@mui/icons-material/GroupWork";
import CategoryIcon from "@mui/icons-material/Category";
import BuildIcon from "@mui/icons-material/Build";
import { useNavigate } from "react-router-dom/dist";
import PaidIcon from "@mui/icons-material/Paid";
import {
  Typography,
  MenuItem,
  MenuList,
  ListItemText,
  ListItem,
  ListItemAvatar,
  ListItemIcon,
} from "@mui/material";
import { logout } from "../../reducers/user/userSlice";
import { displayMenu } from "../../reducers/expariences/expariencesSlice";
import {
  cleanCurrentDesignAndRedirect,
  crmToggleAction,
} from "../../reducers/myDesigns/myDesignsSlice";
import GoldenSwitch from "../goldenSwitch/GoldenSwitch";
import { update3dView } from "../../reducers/configurator/configuratorSlice";
import AccountBadge from "./AccountBadge";

const PREFIX = "TopMenu";

const classes = {
  switchBase: `${PREFIX}-switchBase`,
  checked: `${PREFIX}-checked`,
  track: `${PREFIX}-track`,
  badge: `${PREFIX}-badge`,
  root: `${PREFIX}-root`,
  ToolbarRoot: `${PREFIX}-ToolbarRoot`,
  paper: `${PREFIX}-paper`,
  appBar: `${PREFIX}-appBar`,
  appBarCrm: `${PREFIX}-appBarCrm`,
  hide: `${PREFIX}-hide`,
  drawer: `${PREFIX}-drawer`,
  drawerPaper: `${PREFIX}-drawerPaper`,
  rightMenuContainer: `${PREFIX}-rightMenuContainer`,
  rightMenuContainerPosition: `${PREFIX}-rightMenuContainerPosition`,
  rightMenuContainerPositionDesktop: `${PREFIX}-rightMenuContainerPositionDesktop`,
  drawerHeader: `${PREFIX}-drawerHeader`,
  content: `${PREFIX}-content`,
  search: `${PREFIX}-search`,
  searchIcon: `${PREFIX}-searchIcon`,
  inputRoot: `${PREFIX}-inputRoot`,
  inputInput: `${PREFIX}-inputInput`,
  accountCircleIcon: `${PREFIX}-accountCircleIcon`,
  accountCircleIconDesktop: `${PREFIX}-accountCircleIconDesktop`,
  searchContainer: `${PREFIX}-searchContainer`,
  cursorPointer: `${PREFIX}-cursorPointer`,
  logout: `${PREFIX}-logout`,
  desktopIconSize: `${PREFIX}-desktopIconSize`,
  avatarIconSize: `${PREFIX}-avatarIconSize`,
  expandButtonMobileWidth: `${PREFIX}-expandButtonMobileWidth`,
  alignTopRightElements: `${PREFIX}-alignTopRightElements`,
  popper: `${PREFIX}-popper`,
  loader: `${PREFIX}-loader`,
  ul: `${PREFIX}-ul`,
  listSection: `${PREFIX}-listSection`,
  subheaderList: `${PREFIX}-subheaderList`,
  noResultsSearchText: `${PREFIX}-noResultsSearchText`,
  iconContainer: `${PREFIX}-iconContainer`,
  listItemRoot: `${PREFIX}-listItemRoot`,
  filterButtonContainer: `${PREFIX}-filterButtonContainer`,
  iconButtonStyle: `${PREFIX}-iconButtonStyle`,
  menuListContainer: `${PREFIX}-menuListContainer`,
};

const Root = styled("div")(({ theme }) => ({
  [`& .${classes.root}`]: {
    display: "flex",
    minHeight: "56px",
  },

  [`& .${classes.ToolbarRoot}`]: {
    justifyContent: "space-between",
  },

  [`& .${classes.paper}`]: {
    marginRight: theme.spacing(2),
  },

  [`& .${classes.appBar}`]: {
    color: "#D3AF5F",
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },

  [`& .${classes.appBarCrm}`]: {
    backgroundColor: "#8F8F8F",
    color: "#000000",
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },

  [`& .${classes.hide}`]: {
    display: "none",
  },

  [`& .${classes.drawer}`]: {
    width: drawerWidth,
    flexShrink: 0,
  },

  [`& .${classes.drawerPaper}`]: {
    width: drawerWidth,
    backgroundColor: "#424242",
  },

  [`& .${classes.rightMenuContainer}`]: {
    width: "80px",
  },

  [`& .${classes.rightMenuContainerPosition}`]: {
    position: "absolute",
    right: "0",
  },

  [`& .${classes.rightMenuContainerPositionDesktop}`]: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    position: "absolute",
    right: "24px",
  },

  [`& .${classes.drawerHeader}`]: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: "space-between",
    "& > label": {
      marginLeft: "0.5rem",
    },
  },

  [`& .${classes.content}`]: {
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: -drawerWidth,
  },

  [`& .${classes.search}`]: {
    position: "relative",
    left: "55%",
    transform: "translateX(-50%)",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    "&:hover": {
      backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginLeft: 0,
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(1),
      width: "auto",
    },
    [theme.breakpoints.between("xs", "md")]: {
      marginLeft: theme.spacing(1),
      width: "auto",
    },
  },

  [`& .${classes.searchIcon}`]: {
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  [`& .${classes.inputRoot}`]: {
    color: "inherit",
  },

  [`& .${classes.inputInput}`]: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: "20ch",
      "&:focus": {
        width: "26ch",
      },
    },
    [theme.breakpoints.between("xs", "md")]: {
      width: "6ch",
      "&:focus": {
        width: "10ch",
      },
    },
  },

  [`& .${classes.accountCircleIcon}`]: {
    width: "35px",
    height: "35px",
    transform: "translateY(5px)",
  },

  [`& .${classes.accountCircleIconDesktop}`]: {
    width: "24px",
    height: "24px",
    cursor: "pointer",
  },

  [`& .${classes.searchContainer}`]: {
    position: "relative",
    left: "50%",
    transform: "translateX(-50%)",
  },

  [`& .${classes.cursorPointer}`]: {
    cursor: "pointer",
  },

  [`& .${classes.logout}`]: {
    width: "100%",
    borderTop: "1px solid rgba(255, 255, 255, 0.12)",
  },

  [`& .${classes.desktopIconSize}`]: {
    width: "30px",
    height: "30px",
  },

  [`& .${classes.avatarIconSize}`]: {
    width: "55px",
    height: "55px",
    position: "relative",
    right: "-10px",
  },

  [`& .${classes.expandButtonMobileWidth}`]: {
    minWidth: "30px",
  },

  [`& .${classes.alignTopRightElements}`]: {
    display: "flex",
    flexDirection: "row",
  },

  [`&.${classes.popper}`]: {
    backgroundColor: "#424242",
    width: "100vw",
    maxWidth: 450,
    minHeight: 100,
    maxHeight: 450,
    overflow: "auto",
    "&::-webkit-scrollbar": {
      width: "5px",
      height: "5px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: theme.palette.primary.main,
      borderRadius: "3px",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "rgb(181 154 79 / 58%)",
      borderRadius: "10px",
    },
  },

  [`& .${classes.loader}`]: {
    width: "100vw",
    maxWidth: 450,
    minHeight: 100,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#424242",
  },

  [`& .${classes.ul}`]: {
    backgroundColor: "inherit",
    padding: 0,
  },

  [`& .${classes.listSection}`]: {
    backgroundColor: "inherit",
  },

  [`& .${classes.subheaderList}`]: {
    backgroundColor: "#424242",
    color: theme.palette.primary.main,
    fontSize: "20px",
  },

  [`& .${classes.noResultsSearchText}`]: {
    textAlign: "center",
    marginTop: "2rem !important",
  },

  [`& .${classes.iconContainer}`]: {
    width: "30px",
    height: "30px",
    borderRadius: "25%",
    padding: "3px",
  },

  [`& .${classes.listItemRoot}`]: {
    backgroundColor: "#424242",
  },

  [`& .${classes.filterButtonContainer}`]: {
    padding: theme.spacing(0, 1),
    height: "100%",
    position: "absolute",
    zIndex: "99",
    // pointerEvents: 'none',
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  [`& .${classes.iconButtonStyle}`]: {
    backgroundColor: "#424242",
    color: "#D3AF5F",
    height: "30px",
    width: "30px",
    "&:hover": {
      backgroundColor: "#D3AF5F",
      color: "#424242",
    },
  },

  [`& .${classes.menuListContainer}`]: {
    maxHeight: "100vh",
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      width: "5px",
      height: "5px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: theme.palette.primary.main,
      borderRadius: "3px",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "rgb(181 154 79 / 58%)",
      borderRadius: "10px",
    },
  },
}));

const drawerWidth = 240;

function HideOnScroll({ setOpenResult, ...props }) {
  const dispatch = useDispatch();
  const { children, window } = props;
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger({ target: window ? window() : undefined });
  dispatch(displayMenu(trigger));
  if (trigger) {
    setOpenResult(false);
  }
  return (
    <Slide in={!trigger} direction="down">
      {children}
    </Slide>
  );
}

export default function PersistentDrawerLeft(props) {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const theme = useTheme();
  const { t } = useTranslation();
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search, 300);
  const [results, setResults] = useState(null);
  const history = useNavigate();
  const loggedIn = useSelector((state) => state.user.loggedIn);
  const userAvatar = useSelector(
    (state) => loggedIn && state.user.currentUser.accountDetails.avatar
  );
  const userRole = useSelector(
    (state) => state.user?.currentUser?.account?.role
  );
  const isSuperAdmin = useSelector(
    (state) => state.user?.currentUser?.account?.isSuperAdmin
  );
  const userRights = useSelector(
    (state) => state.user?.currentUser?.account?.rights
  );
  const accountEmail = useSelector(
    (state) => state.user?.currentUser?.account?.email
  );
  const accountDetailsEmail = useSelector(
    (state) => state.user?.currentUser?.accountDetails?.account?.email
  );
  const crmToggle = useSelector((state) => state.myDesigns?.crmEnabled);
  const [myAvatar, setMyAvatar] = useState();
  const { width } = useViewport();
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const [searching, setSearching] = React.useState(false);

  const searchRef = React.useRef(null);
  const [openResult, setOpenResult] = React.useState(false);
  const location = useLocation();

  React.useMemo(() => {
    if (search && search.length > 0) {
      setSearching(true);
      searchService.search(search).then((data) => {
        setResults(data);
        setSearching(false);
      });
    }
  }, [debouncedSearch]);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const handleCloseSearch = (event) => {
    if (searchRef.current && searchRef.current.contains(event.target)) {
      return;
    }
    setOpenResult(false);
  };

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    }
  }

  useEffect(() => {
    const splittedString = userAvatar?.split("/");
    const userId = splittedString
      ? splittedString[splittedString.length - 1].split(".")[0].split("-")[1]
      : 1;
    setMyAvatar(
      userAvatar?.includes("RPM")
        ? `https://api.readyplayer.me/v1/avatars/${userId}.png`
        : userAvatar
    );
  }, [userAvatar]);

  const handleRedirectToSearch = (item, key, event) => {
    dispatch(update3dView(false));
    event.preventDefault();
    event.stopPropagation();
    let redirect;
    if (key === "frames") {
      redirect = () =>
        history(`/mydesign/${item.id}`, {
          state: { from: "search", index: 0, key, item },
        });
    } else if (key === "targets") {
      redirect = () =>
        history(`/mydesign/${item.frameId}`, {
          state: { from: "search", index: 0, key, item },
        });
    } else if (key === "zones") {
      redirect = () => history(`/mydesign/${item.frameId}/zone/${item.id}/`);
    } else if (key === "expariences") {
      redirect = () =>
        history(`/myExpariences/${item.id}`, {
          state: { from: "search", type: "open" },
        });
    }
    dispatch(
      cleanCurrentDesignAndRedirect({
        frameId: item.frameId,
        cb: () => redirect(),
      })
    );
    setOpenResult(false);
  };

  function handleCrmToggleChange() {
    if (
      !location.pathname.includes("myDesigns") &&
      !location.pathname.includes("mydesign") &&
      !crmToggle
    )
      history("/myDesigns");
    dispatch(crmToggleAction());
  }

  function getListItemText(f) {
    return `${f.label}${f.target ? " / " + f.target : ""}${
      f.frameLabel ? " / " + f.frameLabel : ""
    }`;
  }

  const SearchComponent = () => {
    return (
      <ClickAwayListener onClickAway={handleCloseSearch}>
        <Root>
          <Popper
            open={openResult}
            anchorEl={searchRef.current}
            style={{ zIndex: 9999 }}
            className={classes.searchPopper}
          >
            <Paper elevation={0}>
              <Root className={classes.popper}>
                <List subheader={<li />}>
                  {results && Object.keys(results).length === 0 && (
                    <Typography
                      variant="body1"
                      className={classes.noResultsSearchText}
                    >
                      {t("homePage.myDesign.noResults")}
                    </Typography>
                  )}
                  {searching ? (
                    <div className={classes.loader}>
                      <CircularProgress />
                    </div>
                  ) : (
                    results &&
                    (results.expariences ||
                      results.frames ||
                      results.targets ||
                      results.zones) &&
                    Object.keys(results)
                      .sort()
                      .map((key) => {
                        return (
                          <li
                            key={`section-${key}`}
                            className={classes.listSection}
                          >
                            <ul className={classes.ul}>
                              <ListSubheader className={classes.subheaderList}>
                                {`${key.toUpperCase()}`}
                              </ListSubheader>
                              {results[key].map((f, index) => {
                                return (
                                  <div
                                    key={`element-to-redirect-${index + 1}`}
                                    className={classes.listItemRoot}
                                  >
                                    <ListItem
                                      alignItems="flex-start"
                                      onClick={(e) =>
                                        handleRedirectToSearch(f, key, e)
                                      }
                                    >
                                      <ListItemAvatar>
                                        <Avatar
                                          alt={`design-${f.label}`}
                                          src={
                                            f.imageUrl
                                              ? f.imageUrl
                                              : f.imageBorderlessUrl
                                          }
                                        />
                                      </ListItemAvatar>
                                      <ListItemText
                                        primary={getListItemText(f)}
                                        className="search-result"
                                      />
                                    </ListItem>
                                    <Divider />
                                  </div>
                                );
                              })}
                            </ul>
                          </li>
                        );
                      })
                  )}
                </List>
              </Root>
            </Paper>
          </Popper>
        </Root>
      </ClickAwayListener>
    );
  };

  if (
    location.pathname.includes("webview") ||
    location.pathname.includes("/m/") ||
    location.pathname.includes("/leaderboard") ||
    location.pathname.includes("/admin/models")
  ) {
    return null;
  } else {
    return loggedIn && location.pathname.indexOf("mobile") < 0 ? (
      <Root>
        <div
          className={classes.root}
          style={{ display: location.pathname.includes("player") && "none" }}
        >
          <CssBaseline />
          {width <= 975 ? (
            <HideOnScroll setOpenResult={setOpenResult} {...props}>
              <AppBar
                position="fixed"
                className={clsx({
                  [classes.appBar]: true,
                  [classes.appBarCrm]: crmToggle,
                })}
              >
                <Toolbar className={classes.ToolbarRoot}>
                  {/* <div className="menu-logo"/> */}
                  <div
                    className={crmToggle ? "menu-logo-crm" : "menu-logo"}
                    onClick={() => {
                      if (crmToggle) history("/myDesigns");
                      else history("/");
                    }}
                  />

                  <div className={classes.search}>
                    {crmToggle ? (
                      <div className={classes.filterButtonContainer}>
                        <IconButton
                          className={classes.iconButtonStyle}
                          onClick={() => history(`/myDesigns`)}
                          size="large"
                        >
                          <TuneIcon />
                        </IconButton>
                      </div>
                    ) : (
                      <div className={classes.searchIcon}>
                        <SearchIcon />
                      </div>
                    )}
                    <InputBase
                      placeholder={t("topMenu.searchBar")}
                      value={search}
                      onChange={(e) => {
                        setOpenResult(true);
                        setSearch(e.target.value);
                      }}
                      onFocus={() => {
                        setOpenResult(true);
                      }}
                      classes={{
                        root: classes.inputRoot,
                        input: classes.inputInput,
                      }}
                      inputProps={{ "aria-label": "search" }}
                      ref={searchRef}
                    />
                    {(search.length > 0 ||
                      (results &&
                        search.length === 0 &&
                        Object.keys(results).length > 0)) && (
                      <SearchComponent />
                    )}
                  </div>
                  <div className={classes.alignTopRightElements}>
                    <AccountBadge />
                    <Button
                      ref={anchorRef}
                      aria-controls={open ? "menu-list-grow" : undefined}
                      aria-haspopup="true"
                      onClick={handleToggle}
                      className={classes.expandButtonMobileWidth}
                    >
                      <ExpandMoreIcon
                        className={classes.rightMenuContainerPosition}
                      />
                    </Button>
                    <Popper
                      open={open}
                      anchorEl={anchorRef.current}
                      role={undefined}
                      transition
                      disablePortal
                    >
                      {({ TransitionProps, placement }) => (
                        <Grow
                          {...TransitionProps}
                          style={{
                            transformOrigin:
                              placement === "bottom"
                                ? "center top"
                                : "center bottom",
                            backgroundColor: "#424242",
                          }}
                        >
                          <Paper>
                            <ClickAwayListener onClickAway={handleClose}>
                              <MenuList
                                className={classes.menuListContainer}
                                autoFocusItem={open}
                                id="menu-list-grow"
                                onKeyDown={handleListKeyDown}
                              >
                                <MenuItem
                                  onClick={(e) => {
                                    handleClose(e);
                                    history("/account");
                                  }}
                                >
                                  {myAvatar && (
                                    <Badge
                                      badgeContent="!"
                                      color="secondary"
                                      overlap="rectangular"
                                      invisible={
                                        accountEmail || accountDetailsEmail
                                          ? true
                                          : false
                                      }
                                      sx={{
                                        padding: "0 4px",
                                      }}
                                    >
                                      <Avatar
                                        src={myAvatar}
                                        alt="my Avatar"
                                        onClick={() => history("/account")}
                                        className={clsx(
                                          myAvatar.includes("RPM")
                                            ? classes.avatarIconSize
                                            : classes.desktopIconSize,
                                          classes.cursorPointer
                                        )}
                                        style={{ marginRight: "12px" }}
                                      />
                                    </Badge>
                                  )}
                                  {!myAvatar && (
                                    <Badge
                                      badgeContent="!"
                                      color="secondary"
                                      overlap="rectangular"
                                      invisible={
                                        accountEmail || accountDetailsEmail
                                          ? true
                                          : false
                                      }
                                      sx={{
                                        padding: "0 4px",
                                      }}
                                    >
                                      <AccountCircleIcon
                                        className={
                                          classes.accountCircleIconDesktop
                                        }
                                        style={{ marginRight: "12px" }}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          history("/account");
                                        }}
                                      />
                                    </Badge>
                                  )}
                                  <Typography variant="body1">
                                    {t("topMenu.profile")}
                                  </Typography>
                                </MenuItem>
                                <MenuItem>
                                  {(isSuperAdmin ||
                                    isUserAuthorized(
                                      userRole,
                                      userRights,
                                      "Crm"
                                    )) && (
                                    <>
                                      <GoldenSwitch
                                        checked={crmToggle}
                                        name="crm-toggle-button"
                                        onChange={() => handleCrmToggleChange()}
                                        label="CRM mode"
                                      />
                                    </>
                                  )}
                                </MenuItem>
                                {crmToggle ? (
                                  <Divider />
                                ) : (
                                  <div>
                                    <Divider />
                                    <ListSubheader
                                      sx={{
                                        backgroundColor:
                                          "rgba(42, 42, 42, 0.7)",
                                      }}
                                    >
                                      Administration
                                    </ListSubheader>
                                    <List>
                                      {isUserAuthorized(
                                        userRole,
                                        userRights,
                                        "exp"
                                      ) && (
                                        <ListItem
                                          button
                                          key="admin-my-expariences"
                                          onClick={() => {
                                            history("/myExpariences");
                                            setOpen(false);
                                          }}
                                        >
                                          <ListItemIcon>
                                            <div
                                              className={classes.iconContainer}
                                              style={{
                                                backgroundColor: "#1c364f",
                                              }}
                                            >
                                              <Dashboard />
                                            </div>
                                          </ListItemIcon>
                                          <ListItemText
                                            primary={t(
                                              "topMenu.adminExparience"
                                            )}
                                          />
                                        </ListItem>
                                      )}
                                      {isUserAuthorized(
                                        userRole,
                                        userRights,
                                        "designs"
                                      ) && (
                                        <ListItem
                                          button
                                          key="admin-myDesigns"
                                          onClick={() => {
                                            history("/myDesigns");
                                            setOpen(false);
                                          }}
                                        >
                                          <ListItemIcon>
                                            <div
                                              className={classes.iconContainer}
                                              style={{
                                                backgroundColor: "#ea58a1",
                                              }}
                                            >
                                              <BurstMode />
                                            </div>
                                          </ListItemIcon>
                                          <ListItemText
                                            primary={t("topMenu.myDesigns")}
                                          />
                                        </ListItem>
                                      )}
                                      {userRole === "ADMIN" && (
                                        <React.Fragment>
                                          {(isSuperAdmin ||
                                            isUserAuthorized(
                                              userRole,
                                              userRights,
                                              "faz"
                                            )) && (
                                            <ListItem
                                              button
                                              key="admin-dma"
                                              onClick={() => {
                                                history("/admin/dma/page");
                                                setOpen(false);
                                              }}
                                            >
                                              <ListItemIcon>
                                                <div
                                                  className={
                                                    classes.iconContainer
                                                  }
                                                  style={{
                                                    backgroundColor: "#09a137",
                                                  }}
                                                >
                                                  <PhonelinkSetup />
                                                </div>
                                              </ListItemIcon>
                                              <ListItemText
                                                primary={t("topMenu.adminHome")}
                                              />
                                            </ListItem>
                                          )}
                                          {(isSuperAdmin ||
                                            isUserAuthorized(
                                              userRole,
                                              userRights,
                                              "rights"
                                            )) && (
                                            <ListItem
                                              button
                                              key="admin-users-rights"
                                              onClick={() => {
                                                history(
                                                  "/admin/users?mode=rights"
                                                );
                                                setOpen(false);
                                              }}
                                            >
                                              <ListItemIcon>
                                                <div
                                                  className={
                                                    classes.iconContainer
                                                  }
                                                  style={{
                                                    backgroundColor: "#09a137",
                                                  }}
                                                >
                                                  <BuildIcon />
                                                </div>
                                              </ListItemIcon>
                                              <ListItemText
                                                primary={t(
                                                  "topMenu.adminRights"
                                                )}
                                              />
                                            </ListItem>
                                          )}
                                          {(isSuperAdmin ||
                                            isUserAuthorized(
                                              userRole,
                                              userRights,
                                              "classes"
                                            )) && (
                                            <ListItem
                                              button
                                              key="admin-classes"
                                              onClick={() => {
                                                history("/classes");
                                                setOpen(false);
                                              }}
                                            >
                                              <ListItemIcon>
                                                <div
                                                  className={
                                                    classes.iconContainer
                                                  }
                                                  style={{
                                                    backgroundColor: "#09a137",
                                                  }}
                                                >
                                                  <BuildIcon />
                                                </div>
                                              </ListItemIcon>
                                              <ListItemText
                                                primary={t("topMenu.classes")}
                                              />
                                            </ListItem>
                                          )}
                                          {(isSuperAdmin ||
                                            isUserAuthorized(
                                              userRole,
                                              userRights,
                                              "payments"
                                            )) && (
                                            <ListItem
                                              button
                                              key="admin-payments"
                                              onClick={() => {
                                                history("/admin/payments");
                                                setOpen(false);
                                              }}
                                            >
                                              <ListItemIcon>
                                                <div
                                                  className={
                                                    classes.iconContainer
                                                  }
                                                  style={{
                                                    backgroundColor: "#09a137",
                                                  }}
                                                >
                                                  <PaidIcon />
                                                </div>
                                              </ListItemIcon>
                                              <ListItemText
                                                primary={t(
                                                  "topMenu.adminPayments"
                                                )}
                                              />
                                            </ListItem>
                                          )}
                                          {(isSuperAdmin ||
                                            isUserAuthorized(
                                              userRole,
                                              userRights,
                                              "QRCodes"
                                            )) && (
                                            <ListItem
                                              button
                                              key="admin-QRCodes"
                                              onClick={() => {
                                                history("/admin/QRCodes");
                                                setOpen(false);
                                              }}
                                            >
                                              <ListItemIcon>
                                                <div
                                                  className={
                                                    classes.iconContainer
                                                  }
                                                  style={{
                                                    backgroundColor: "#09a137",
                                                  }}
                                                >
                                                  <WallpaperIcon />
                                                </div>
                                              </ListItemIcon>
                                              <ListItemText
                                                primary={t("topMenu.qrCodes")}
                                              />
                                            </ListItem>
                                          )}
                                          {(isSuperAdmin ||
                                            isUserAuthorized(
                                              userRole,
                                              userRights,
                                              "Hdr"
                                            )) && (
                                            <ListItem
                                              button
                                              key="admin-Hdr"
                                              onClick={() => {
                                                history("/admin/hdr");
                                                setOpen(false);
                                              }}
                                            >
                                              <ListItemIcon>
                                                <div
                                                  className={
                                                    classes.iconContainer
                                                  }
                                                  style={{
                                                    backgroundColor: "#09a137",
                                                  }}
                                                >
                                                  <WallpaperIcon />
                                                </div>
                                              </ListItemIcon>
                                              <ListItemText
                                                primary={t("topMenu.hdr")}
                                              />
                                            </ListItem>
                                          )}
                                          {(isSuperAdmin ||
                                            isUserAuthorized(
                                              userRole,
                                              userRights,
                                              "models"
                                            )) && (
                                            <ListItem
                                              button
                                              key="admin-models"
                                              onClick={() => {
                                                history("/admin/models");
                                                setOpen(false);
                                              }}
                                            >
                                              <ListItemIcon>
                                                <div
                                                  className={
                                                    classes.iconContainer
                                                  }
                                                  style={{
                                                    backgroundColor: "#09a137",
                                                  }}
                                                >
                                                  <WallpaperIcon />
                                                </div>
                                              </ListItemIcon>
                                              <ListItemText
                                                primary={t("topMenu.models")}
                                              />
                                            </ListItem>
                                          )}
                                          {isUserAuthorized(
                                            userRole,
                                            userRights,
                                            "grafana"
                                          ) && (
                                            <ListItem
                                              button
                                              key="admin-grafana"
                                              onClick={() => {
                                                window.open(
                                                  process.env
                                                    .REACT_APP_GRAFANA_URL,
                                                  "_blank"
                                                );
                                                setOpen(false);
                                              }}
                                            >
                                              <ListItemIcon>
                                                <div
                                                  className={
                                                    classes.iconContainer
                                                  }
                                                  style={{
                                                    backgroundColor: "#D3AF5F",
                                                  }}
                                                >
                                                  <Assessment />
                                                </div>
                                              </ListItemIcon>
                                              <ListItemText
                                                primary={t("dashboard.grafana")}
                                              />
                                            </ListItem>
                                          )}
                                          {isUserAuthorized(
                                            userRole,
                                            userRights,
                                            "cat"
                                          ) && (
                                            <ListItem
                                              button
                                              key="admin-categories"
                                              onClick={() => {
                                                history("/admin/categories");
                                                setOpen(false);
                                              }}
                                            >
                                              <ListItemIcon>
                                                <div
                                                  className={
                                                    classes.iconContainer
                                                  }
                                                  style={{
                                                    backgroundColor: "#af2819",
                                                  }}
                                                >
                                                  <CategoryIcon />
                                                </div>
                                              </ListItemIcon>
                                              <ListItemText
                                                primary={t(
                                                  "topMenu.adminCategories"
                                                )}
                                              />
                                            </ListItem>
                                          )}
                                          {isUserAuthorized(
                                            userRole,
                                            userRights,
                                            "camp"
                                          ) && (
                                            <ListItem
                                              button
                                              key="admin-campaigns"
                                              onClick={() => {
                                                history("/admin/campaigns");
                                                setOpen(false);
                                              }}
                                            >
                                              <ListItemIcon>
                                                <div
                                                  className={
                                                    classes.iconContainer
                                                  }
                                                  style={{
                                                    backgroundColor: "#458faf",
                                                  }}
                                                >
                                                  <GroupWorkIcon />
                                                </div>
                                              </ListItemIcon>
                                              <ListItemText
                                                primary={t(
                                                  "topMenu.adminCampaigns"
                                                )}
                                              />
                                            </ListItem>
                                          )}
                                          {(isSuperAdmin ||
                                            isUserAuthorized(
                                              userRole,
                                              userRights,
                                              "users"
                                            )) && (
                                            <ListItem
                                              button
                                              key="admin-users"
                                              onClick={() => {
                                                history("/admin/users");
                                                setOpen(false);
                                              }}
                                            >
                                              <ListItemIcon>
                                                <div
                                                  className={
                                                    classes.iconContainer
                                                  }
                                                  style={{
                                                    backgroundColor: "#af964a",
                                                  }}
                                                >
                                                  <SupervisedUserCircle />
                                                </div>
                                              </ListItemIcon>
                                              <ListItemText
                                                primary={t(
                                                  "topMenu.adminUsers"
                                                )}
                                              />
                                            </ListItem>
                                          )}
                                          {isUserAuthorized(
                                            userRole,
                                            userRights,
                                            "ent"
                                          ) && (
                                            <ListItem
                                              button
                                              key="admin-entities"
                                              onClick={() => {
                                                history("/admin/entities");
                                                setOpen(false);
                                              }}
                                            >
                                              <ListItemIcon>
                                                <div
                                                  className={
                                                    classes.iconContainer
                                                  }
                                                  style={{
                                                    backgroundColor: "#bee455",
                                                  }}
                                                >
                                                  <Business />
                                                </div>
                                              </ListItemIcon>
                                              <ListItemText
                                                primary={t(
                                                  "topMenu.adminEntities"
                                                )}
                                              />
                                            </ListItem>
                                          )}
                                          {isUserAuthorized(
                                            userRole,
                                            userRights,
                                            "journeys"
                                          ) && (
                                            <ListItem
                                              button
                                              key="admin-journeys"
                                              onClick={() => {
                                                history("/admin/journeys");
                                                setOpen(false);
                                              }}
                                            >
                                              <ListItemIcon>
                                                <div
                                                  className={
                                                    classes.iconContainer
                                                  }
                                                  style={{
                                                    backgroundColor: "#bee455",
                                                  }}
                                                >
                                                  <Business />
                                                </div>
                                              </ListItemIcon>
                                              <ListItemText
                                                primary={t(
                                                  "topMenu.adminJourneys"
                                                )}
                                              />
                                            </ListItem>
                                          )}
                                        </React.Fragment>
                                      )}
                                    </List>
                                  </div>
                                )}
                                <MenuItem style={{ marginTop: "1.5rem" }}>
                                  <a
                                    style={{
                                      display: "flex",
                                      textDecoration: "none",
                                    }}
                                    href={`mailto:hello@artdesignstory.fr?subject=${t(
                                      "topMenu.mailSubject"
                                    )}`}
                                    target="_blank"
                                    rel="noreferrer"
                                  >
                                    <img
                                      id="contactSupport"
                                      alt="contact-support-icon"
                                      src={ContactSupport}
                                      style={{
                                        marginRight: "12px",
                                      }}
                                    />
                                    <Typography variant="body1">
                                      {t("topMenu.contactUs")}
                                    </Typography>
                                  </a>
                                </MenuItem>

                                <Divider />
                                <MenuItem
                                  sx={{
                                    marginBottom: !crmToggle ? "3.5rem" : 0,
                                  }}
                                  onClick={(e) => {
                                    handleClose(e);
                                    enqueueSnackbar(t("toasts.logout"), {
                                      variant: "success",
                                    });
                                    dispatch(logout());
                                    history("/");
                                  }}
                                >
                                  <PowerSettingsNewIcon
                                    style={{ marginRight: "12px" }}
                                  />
                                  <Typography variant="body1">
                                    {t("topMenu.logout")}
                                  </Typography>
                                </MenuItem>
                              </MenuList>
                            </ClickAwayListener>
                          </Paper>
                        </Grow>
                      )}
                    </Popper>
                  </div>
                </Toolbar>
              </AppBar>
            </HideOnScroll>
          ) : (
            <AppBar
              position="fixed"
              className={clsx({
                [classes.appBar]: true,
                [classes.appBarCrm]: crmToggle,
              })}
            >
              <Toolbar>
                <div
                  className={crmToggle ? "menu-logo-crm" : "menu-logo"}
                  onClick={() => {
                    if (crmToggle) history("/myDesigns");
                    else history("/");
                  }}
                />
                <div className={classes.searchContainer}>
                  <div className={classes.search}>
                    {crmToggle ? (
                      <div className={classes.filterButtonContainer}>
                        <IconButton
                          className={classes.iconButtonStyle}
                          onClick={() => history(`/myDesigns`)}
                          size="large"
                        >
                          <TuneIcon />
                        </IconButton>
                      </div>
                    ) : (
                      <div className={classes.searchIcon}>
                        <SearchIcon />
                      </div>
                    )}
                    <InputBase
                      placeholder={t("topMenu.searchBar")}
                      value={search}
                      onChange={(e) => {
                        setOpenResult(true);
                        setSearch(e.target.value);
                      }}
                      onFocus={() => {
                        setOpenResult(true);
                      }}
                      classes={{
                        root: classes.inputRoot,
                        input: classes.inputInput,
                      }}
                      inputProps={{ "aria-label": "search" }}
                      ref={searchRef}
                    />
                    {(search.length > 0 ||
                      (results &&
                        search.length === 0 &&
                        Object.keys(results).length > 0)) && (
                      <SearchComponent />
                    )}
                  </div>
                </div>
                <div
                  className={clsx(
                    classes.rightMenuContainer,
                    classes.rightMenuContainerPosition,
                    classes.rightMenuContainerPositionDesktop
                  )}
                >
                  {myAvatar && (
                    <Badge
                      badgeContent="!"
                      color="secondary"
                      overlap="rectangular"
                      invisible={
                        accountEmail || accountDetailsEmail ? true : false
                      }
                      sx={{
                        padding: "0 4px",
                      }}
                    >
                      <Avatar
                        src={myAvatar}
                        alt="my Avatar"
                        onClick={() => history("/account")}
                        className={clsx(
                          classes.cursorPointer,
                          myAvatar.includes("RPM")
                            ? classes.avatarIconSize
                            : classes.desktopIconSize
                        )}
                      />
                    </Badge>
                  )}
                  {!myAvatar && (
                    <Badge
                      badgeContent="!"
                      color="secondary"
                      overlap="rectangular"
                      invisible={
                        accountEmail || accountDetailsEmail ? true : false
                      }
                      sx={{
                        padding: "0 4px",
                      }}
                    >
                      <AccountCircleIcon
                        className={clsx(
                          open && classes.hide,
                          !open && classes.accountCircleIconDesktop,
                          classes.cursorPointer
                        )}
                        onClick={() => history("/account")}
                      />
                    </Badge>
                  )}
                  <IconButton
                    color="inherit"
                    aria-label="open drawer"
                    edge="end"
                    onClick={(e) => setOpen(true)}
                    className={clsx(open && classes.hide)}
                    size="large"
                  >
                    <MenuIcon />
                  </IconButton>
                  <Drawer
                    className={classes.drawer}
                    variant="temporary"
                    anchor="right"
                    open={open}
                    onClose={() => setOpen(false)}
                    classes={{
                      paper: classes.drawerPaper,
                    }}
                  >
                    <Root>
                      <div className={classes.drawerHeader}>
                        {(isSuperAdmin ||
                          isUserAuthorized(userRole, userRights, "Crm")) && (
                          <GoldenSwitch
                            checked={crmToggle}
                            name="crm-toggle-button"
                            onChange={() => handleCrmToggleChange()}
                            label="CRM mode"
                          />
                        )}
                        <IconButton onClick={() => setOpen(false)} size="large">
                          {theme.direction === "rtl" ? (
                            <ChevronLeftIcon />
                          ) : (
                            <ChevronRightIcon />
                          )}
                        </IconButton>
                      </div>
                      <Divider />
                      <List>
                        <ListItem
                          button
                          key="profile"
                          onClick={() => {
                            history("/account");
                            setOpen(false);
                          }}
                        >
                          <ListItemIcon>
                            {myAvatar && (
                              <Badge
                                badgeContent="!"
                                color="secondary"
                                overlap="rectangular"
                                invisible={
                                  accountEmail || accountDetailsEmail
                                    ? true
                                    : false
                                }
                                sx={{
                                  padding: "0 4px",
                                }}
                              >
                                <Avatar
                                  src={myAvatar}
                                  alt="my Avatar"
                                  className={clsx(
                                    classes.cursorPointer,
                                    classes.desktopIconSize
                                  )}
                                />
                              </Badge>
                            )}
                            {!myAvatar && (
                              <Badge
                                badgeContent="!"
                                color="secondary"
                                overlap="rectangular"
                                invisible={
                                  accountEmail || accountDetailsEmail
                                    ? true
                                    : false
                                }
                                sx={{
                                  padding: "0 4px",
                                }}
                              >
                                <AccountCircleIcon
                                  className={classes.cursorPointer}
                                />
                              </Badge>
                            )}
                          </ListItemIcon>
                          <ListItemText
                            primary={t("topMenu.profile")}
                            onClick={() => {
                              history("/account");
                              setOpen(false);
                            }}
                          />
                        </ListItem>
                        <Divider />
                        <ListItem
                          button
                          key="upload"
                          onClick={() => {
                            history("/upload");
                            setOpen(false);
                          }}
                        >
                          <ListItemIcon>
                            <CloudUploadIcon
                              className={classes.desktopIconSize}
                            />
                          </ListItemIcon>
                          <ListItemText primary={t("topMenu.upload")} />
                        </ListItem>
                        <Divider />
                        <ListItem
                          button
                          key="schedule"
                          onClick={() => {
                            history("/schedule");
                            setOpen(false);
                          }}
                        >
                          <ListItemIcon>
                            <EventIcon className={classes.desktopIconSize} />
                          </ListItemIcon>
                          <ListItemText primary={t("topMenu.schedule")} />
                        </ListItem>
                        <Divider />
                        <ListItem
                          button
                          key="statistic"
                          onClick={() => {
                            history("/statistics");
                            setOpen(false);
                          }}
                        >
                          <ListItemIcon>
                            <Assessment className={classes.desktopIconSize} />
                          </ListItemIcon>
                          <ListItemText primary={t("topMenu.statistics")} />
                        </ListItem>
                      </List>
                      {crmToggle ? (
                        <Divider />
                      ) : (
                        <div>
                          <Divider />
                          <ListSubheader
                            sx={{ backgroundColor: "rgba(42, 42, 42, 0.7)" }}
                          >
                            Administration
                          </ListSubheader>
                          <List className={classes.admin}>
                            {isUserAuthorized(userRole, userRights, "exp") && (
                              <ListItem
                                button
                                key="admin-my-expariences"
                                onClick={() => {
                                  history("/myExpariences");
                                  setOpen(false);
                                }}
                              >
                                <ListItemIcon>
                                  <div
                                    className={classes.iconContainer}
                                    style={{ backgroundColor: "#1c364f" }}
                                  >
                                    <Dashboard />
                                  </div>
                                </ListItemIcon>
                                <ListItemText
                                  primary={t("topMenu.adminExparience")}
                                />
                              </ListItem>
                            )}
                            {isUserAuthorized(
                              userRole,
                              userRights,
                              "designs"
                            ) && (
                              <ListItem
                                button
                                key="admin-myDesigns"
                                onClick={() => {
                                  history("/myDesigns");
                                  setOpen(false);
                                }}
                              >
                                <ListItemIcon>
                                  <div
                                    className={classes.iconContainer}
                                    style={{ backgroundColor: "#ea58a1" }}
                                  >
                                    <BurstMode />
                                  </div>
                                </ListItemIcon>
                                <ListItemText
                                  primary={t("topMenu.myDesigns")}
                                />
                              </ListItem>
                            )}
                            {(isSuperAdmin ||
                              isUserAuthorized(
                                userRole,
                                userRights,
                                "faz"
                              )) && (
                              <ListItem
                                button
                                key="admin-dma"
                                onClick={() => {
                                  history("/admin/dma/page");
                                  setOpen(false);
                                }}
                              >
                                <ListItemIcon>
                                  <div
                                    className={classes.iconContainer}
                                    style={{ backgroundColor: "#09a137" }}
                                  >
                                    <PhonelinkSetup />
                                  </div>
                                </ListItemIcon>
                                <ListItemText
                                  primary={t("topMenu.adminHome")}
                                />
                              </ListItem>
                            )}
                            {(isSuperAdmin ||
                              isUserAuthorized(
                                userRole,
                                userRights,
                                "rights"
                              )) && (
                              <ListItem
                                button
                                key="admin-users-rights"
                                onClick={() => {
                                  history("/admin/users?mode=rights");
                                  setOpen(false);
                                }}
                              >
                                <ListItemIcon>
                                  <div
                                    className={classes.iconContainer}
                                    style={{ backgroundColor: "#09a137" }}
                                  >
                                    <BuildIcon />
                                  </div>
                                </ListItemIcon>
                                <ListItemText
                                  primary={t("topMenu.adminRights")}
                                />
                              </ListItem>
                            )}
                            {(isSuperAdmin ||
                              isUserAuthorized(
                                userRole,
                                userRights,
                                "classes"
                              )) && (
                              <ListItem
                                button
                                key="admin-classes"
                                onClick={() => {
                                  history("/classes");
                                  setOpen(false);
                                }}
                              >
                                <ListItemIcon>
                                  <div
                                    className={classes.iconContainer}
                                    style={{ backgroundColor: "#09a137" }}
                                  >
                                    <BuildIcon />
                                  </div>
                                </ListItemIcon>
                                <ListItemText primary={t("topMenu.classes")} />
                              </ListItem>
                            )}
                            {(isSuperAdmin ||
                              isUserAuthorized(
                                userRole,
                                userRights,
                                "payments"
                              )) && (
                              <ListItem
                                button
                                key="admin-payments"
                                onClick={() => {
                                  history("/admin/payments");
                                  setOpen(false);
                                }}
                              >
                                <ListItemIcon>
                                  <div
                                    className={classes.iconContainer}
                                    style={{ backgroundColor: "#09a137" }}
                                  >
                                    <PaidIcon />
                                  </div>
                                </ListItemIcon>
                                <ListItemText
                                  primary={t("topMenu.adminPayments")}
                                />
                              </ListItem>
                            )}
                            {(isSuperAdmin ||
                              isUserAuthorized(
                                userRole,
                                userRights,
                                "QRCodes"
                              )) && (
                              <ListItem
                                button
                                key="admin-QRCodes"
                                onClick={() => {
                                  history("/admin/QRCodes");
                                  setOpen(false);
                                }}
                              >
                                <ListItemIcon>
                                  <div
                                    className={classes.iconContainer}
                                    style={{ backgroundColor: "#09a137" }}
                                  >
                                    <QrCode2Icon />
                                  </div>
                                </ListItemIcon>
                                <ListItemText primary={t("topMenu.qrCodes")} />
                              </ListItem>
                            )}
                            {(isSuperAdmin ||
                              isUserAuthorized(
                                userRole,
                                userRights,
                                "Hdr"
                              )) && (
                              <ListItem
                                button
                                key="admin-Hdr"
                                onClick={() => {
                                  history("/admin/hdr");
                                  setOpen(false);
                                }}
                              >
                                <ListItemIcon>
                                  <div
                                    className={classes.iconContainer}
                                    style={{ backgroundColor: "#09a137" }}
                                  >
                                    <WallpaperIcon />
                                  </div>
                                </ListItemIcon>
                                <ListItemText primary={t("topMenu.hdr")} />
                              </ListItem>
                            )}
                            {(isSuperAdmin ||
                              isUserAuthorized(
                                userRole,
                                userRights,
                                "models"
                              )) && (
                              <ListItem
                                button
                                key="admin-models"
                                onClick={() => {
                                  history("/admin/models");
                                  setOpen(false);
                                }}
                              >
                                <ListItemIcon>
                                  <div
                                    className={classes.iconContainer}
                                    style={{ backgroundColor: "#09a137" }}
                                  >
                                    <WallpaperIcon />
                                  </div>
                                </ListItemIcon>
                                <ListItemText primary={t("topMenu.models")} />
                              </ListItem>
                            )}
                            {userRole === "ADMIN" && (
                              <React.Fragment>
                                {isUserAuthorized(
                                  userRole,
                                  userRights,
                                  "grafana"
                                ) && (
                                  <ListItem
                                    button
                                    key="admin-grafana"
                                    onClick={() => {
                                      window.open(
                                        process.env.REACT_APP_GRAFANA_URL,
                                        "_blank"
                                      );
                                      setOpen(false);
                                    }}
                                  >
                                    <ListItemIcon>
                                      <div
                                        className={classes.iconContainer}
                                        style={{ backgroundColor: "#D3AF5F" }}
                                      >
                                        <Assessment />
                                      </div>
                                    </ListItemIcon>
                                    <ListItemText
                                      primary={t("dashboard.grafana")}
                                    />
                                  </ListItem>
                                )}
                                {isUserAuthorized(
                                  userRole,
                                  userRights,
                                  "cat"
                                ) && (
                                  <ListItem
                                    button
                                    key="admin-categories"
                                    onClick={() => {
                                      history("/admin/categories");
                                      setOpen(false);
                                    }}
                                  >
                                    <ListItemIcon>
                                      <div
                                        className={classes.iconContainer}
                                        style={{ backgroundColor: "#af2819" }}
                                      >
                                        <CategoryIcon />
                                      </div>
                                    </ListItemIcon>
                                    <ListItemText
                                      primary={t("topMenu.adminCategories")}
                                    />
                                  </ListItem>
                                )}
                                {isUserAuthorized(
                                  userRole,
                                  userRights,
                                  "camp"
                                ) && (
                                  <ListItem
                                    button
                                    key="admin-campaigns"
                                    onClick={() => {
                                      history("/admin/campaigns");
                                      setOpen(false);
                                    }}
                                  >
                                    <ListItemIcon>
                                      <div
                                        className={classes.iconContainer}
                                        style={{ backgroundColor: "#458faf" }}
                                      >
                                        <GroupWorkIcon />
                                      </div>
                                    </ListItemIcon>
                                    <ListItemText
                                      primary={t("topMenu.adminCampaigns")}
                                    />
                                  </ListItem>
                                )}
                                {(isSuperAdmin ||
                                  isUserAuthorized(
                                    userRole,
                                    userRights,
                                    "users"
                                  )) && (
                                  <ListItem
                                    button
                                    key="admin-users"
                                    onClick={() => {
                                      history("/admin/users");
                                      setOpen(false);
                                    }}
                                  >
                                    <ListItemIcon>
                                      <div
                                        className={classes.iconContainer}
                                        style={{ backgroundColor: "#af964a" }}
                                      >
                                        <SupervisedUserCircle />
                                      </div>
                                    </ListItemIcon>
                                    <ListItemText
                                      primary={t("topMenu.adminUsers")}
                                    />
                                  </ListItem>
                                )}
                                {isUserAuthorized(
                                  userRole,
                                  userRights,
                                  "ent"
                                ) && (
                                  <ListItem
                                    button
                                    key="admin-entities"
                                    onClick={() => {
                                      history("/admin/entities");
                                      setOpen(false);
                                    }}
                                  >
                                    <ListItemIcon>
                                      <div
                                        className={classes.iconContainer}
                                        style={{ backgroundColor: "#bee455" }}
                                      >
                                        <Business />
                                      </div>
                                    </ListItemIcon>
                                    <ListItemText
                                      primary={t("topMenu.adminEntities")}
                                    />
                                  </ListItem>
                                )}
                                {isUserAuthorized(
                                  userRole,
                                  userRights,
                                  "journeys"
                                ) && (
                                  <ListItem
                                    button
                                    key="admin-journeys"
                                    onClick={() => {
                                      history("/admin/journeys");
                                      setOpen(false);
                                    }}
                                  >
                                    <ListItemIcon>
                                      <div
                                        className={classes.iconContainer}
                                        style={{ backgroundColor: "#bee455" }}
                                      >
                                        <Business />
                                      </div>
                                    </ListItemIcon>
                                    <ListItemText
                                      primary={t("topMenu.adminJourneys")}
                                    />
                                  </ListItem>
                                )}
                              </React.Fragment>
                            )}
                          </List>
                        </div>
                      )}
                    </Root>
                    <div>
                      <List>
                        <a
                          style={{ display: "flex", textDecoration: "none" }}
                          href={`mailto:hello@artdesignstory.fr?subject=${t(
                            "topMenu.mailSubject"
                          )}`}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <ListItem
                            style={{ marginTop: "1.5rem" }}
                            button
                            key="contact us"
                          >
                            <img
                              id="contactSupport"
                              alt="contact-support-icon"
                              src={ContactSupport}
                              style={{
                                marginRight: "32px",
                              }}
                            />
                            <Typography variant="body1">
                              {t("topMenu.contactUs")}
                            </Typography>
                          </ListItem>
                        </a>
                      </List>
                      <Root>
                        <div className={classes.logout}>
                          <List>
                            <ListItem
                              button
                              key="disconnect"
                              onClick={(e) => {
                                handleClose(e);
                                enqueueSnackbar(t("toasts.logout"), {
                                  variant: "success",
                                });
                                dispatch(logout());
                                history("/");
                              }}
                            >
                              <ListItemIcon>
                                <PowerSettingsNewIcon />
                              </ListItemIcon>
                              <ListItemText primary={t("topMenu.logout")} />
                            </ListItem>
                          </List>
                        </div>
                      </Root>
                    </div>
                  </Drawer>
                </div>
              </Toolbar>
            </AppBar>
          )}
          {loggedIn && !accountEmail && !accountDetailsEmail && (
            <EmailSnackBar isResponsive={width <= 975} />
          )}
        </div>
      </Root>
    ) : (
      <div></div>
    );
  }
}
